import { render, staticRenderFns } from "./SignatureTemplate1.vue?vue&type=template&id=35fff100&"
import script from "./SignatureTemplate1.vue?vue&type=script&lang=js&"
export * from "./SignatureTemplate1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports